import React from "react"
import RPMAdminPatient from "./RPMAdminPatient/RPMAdminPatient"

const RPMAdminComponent = () => <RPMAdminPatient isFromAddPatient />

export default RPMAdminComponent
